<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Check-In Übersicht"
    iconPath="assets/icons/identification-card.svg"
  />

  <mat-dialog-content class="pt-5 h-dvh">
    <app-paginator
      class="mt-8"
      [intervalType]="PaginatorIntervalTypeEnum.MONTH"
      (paginationChange)="fetchData($event.index, $event.year)"
    />

    <div class="border-b border-light-grey">
      <div class="grid grid-cols-4 p-3">
        <p class="col-start-1 col-end-4 font-medium">Name</p>
        <p class="col-start-4 col-end-5 font-medium">Summe</p>
      </div>

      @for (item of sortedLeaderBoard(); track item) {
        <div class="grid grid-cols-4 p-3">
          <p class="col-start-1 col-end-4 font-medium">
            {{ item.user.firstname }} {{ item.user.lastname }}
          </p>
          <p class="col-start-4 col-end-5 font-medium">{{ item.checkInCount }}</p>
        </div>
      } @empty {
        <app-no-entries-placeholder></app-no-entries-placeholder>
      }
    </div>
  </mat-dialog-content>
</div>
